import React from 'react';
import axios from 'axios';
import { Form, Select, Input, message } from 'antd';
import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import formItemLayout from 'components/Portal/formItemLayout';
import stickyErrorAdmissions from 'components/stickyError';


class BiographyNote extends React.Component {
    state = {
        facultyList: [],
        isLoaded: false,
        selectedNote: []
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                stickyError('Whoopsie, please talk to tech support.  Also make sure you are logged in!');
                this.props.isSubmitted();
            }
            else {
                axios.put(apiPath + '/note/addBiographyNote', values, { withCredentials: true }).then(result => {
                    message.success('Saved!');
                });
            }
        })
    }

    getFacultyStaff() {
        axios.get(apiPath + '/folio/getFacultyStaff').then(result => {
            this.setState({ facultyList: result.data, isLoaded: true })
        })
    }

    componentDidMount() {
        this.getFacultyStaff();
    }

    handleChange = (value) => {
        axios.get(apiPath + '/note/getBiographyNote').then(result => {
            result.data.map(res => {
                if (res.id === value) {
                    this.setState({ selectedNote: res.note })
                }
            })
        })
    }

    render() {

        const Option = Select.Option;
        const { getFieldDecorator } = this.props.form;

        return (
            <Form onSubmit={this.handleSubmit} style={{ marginRight: '200px' }}>
                <br />
                <br />
                <br />
                {this.state.isLoaded &&
                    <Form.Item label="List" {...formItemLayout}>
                        {getFieldDecorator('bookingId', {
                            initialValue: ''
                        })(
                            <Select
                                showSearch
                                filterOption={(inputValue, option) => {
                                    return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
                                }}
                                placeholder="Select a person"
                                optionFilterProp="children"
                                onChange={this.handleChange}
                                key={this.state.facultyList.bookingId + this.state.facultyList.evtCode}>
                                {this.state.facultyList.map(faculty => {
                                    return <Option title={faculty.firstName + faculty.lastName} value={faculty.bookingId} key={faculty.bookingId + '' + Date.now()}>{faculty.firstName} {faculty.lastName} {faculty.evtCode}</Option>
                                })}
                            </Select>
                        )}
                    </Form.Item>
                }
                <Form.Item label="Note" {...formItemLayout}>
                    {getFieldDecorator('note', {
                        initialValue: this.state.selectedNote
                    })(
                        <Input.TextArea />
                    )}
                </Form.Item>
                <SaveButton
                    disabled={!this.props.form.isFieldsTouched()}
                    loading={this.props.getStatus().submitting} />
            </Form>
        );
    }
}

export default withSpin(Form.create()(BiographyNote));


// WEBPACK FOOTER //
// ./portal-components/Portal/SchoolInformation/BiographyNote.jsx